export default __webpack_public_path__ + "static/media/image2.371b2fa9.png";